import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Ticket, Copy } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoStrip({ scope = "merch", compact = false }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/promo/featured`, { params: { scope } }).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [scope]);
  if (items.length === 0) return null;
  const copy = (code) => { navigator.clipboard.writeText(code); toast.success(`${code} copied — paste it in your ${scope === "services" ? "booking form" : "cart"}`); };
  return (
    <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.15 }}
      data-testid={`promo-strip${scope === "services" ? "-services" : ""}`} className={`${compact ? "mb-6" : "mt-6"} flex flex-wrap items-center gap-x-5 gap-y-2 bg-[#0C2E2B] text-white rounded-md px-4 py-3 border-l-4 border-[#FFDF00]`}>
      <span className="font-tactical text-[11px] uppercase tracking-[0.25em] text-[#FFDF00] flex items-center gap-1.5"><Ticket className="w-4 h-4" /> Deal{items.length > 1 ? "s" : ""} on now</span>
      {items.map((p) => (
        <button key={p.code} type="button" data-testid={`promo-strip-${p.code}`} onClick={() => copy(p.code)}
          className="group flex items-center gap-2 text-sm hover:text-[#FFDF00] transition-colors">
          <span className="font-bold">{p.label}{p.min_subtotal > 0 ? ` over $${Number(p.min_subtotal).toFixed(0)}` : ""}</span>
          <span className="text-white/60">with code</span>
          <span className="font-mono-data font-black tracking-wider bg-[#FFDF00] text-[#0C2E2B] px-2 py-0.5 rounded group-hover:bg-white transition-colors flex items-center gap-1">{p.code} <Copy className="w-3 h-3" /></span>
          {p.ends_at && <span className="text-[11px] text-white/50">ends {p.ends_at}</span>}
        </button>
      ))}
      <span className="text-[11px] text-white/50 ml-auto">{scope === "services" ? "Enter it in the booking form after your quote" : "Enter it in your cart at checkout"}</span>
    </motion.div>
  );
}
